import { gql } from "@apollo/client"
import {
    PartnershipTierSelectorItemApplylistFragment,
    PartnershipTierSelectorItemTierFragment,
} from "../PartnershipTierSelectorItem/fragment"
import { ContingencyTierSelectorItemApplylistFragment } from "@pallet/features/ApplylistType/components/PartnershipTierSelectorItem/variants/Contingency/fragment"

export const PartnershipTierSelectorFragment = gql`
    fragment PartnershipTierSelectorFragment on ApplylistType {
        id
        showContingencyTier
        primaryColor
        partnershipTiers(showDisabled: false) {
            totalCount
            edges {
                node {
                    id
                    ...PartnershipTierSelectorItemTierFragment
                }
            }
        }
        ...PartnershipTierSelectorItemApplylistFragment
        ...ContingencyTierSelectorItem_applylist
    }
    ${PartnershipTierSelectorItemTierFragment}
    ${PartnershipTierSelectorItemApplylistFragment}
    ${ContingencyTierSelectorItemApplylistFragment}
`
